// Function that takes an array and splits it into chunks
// the size of perChunk. Result will look something like
// [['a','b'], ['c','d'], ['e']]
export function splitArrayIntoChunks<T>(perChunk: number, inputArray: T[]): T[][] {
  if (perChunk >= inputArray.length) {
    return [inputArray];
  }

  return inputArray.reduce((acc: T[][], item, index) => {
    const chunkIndex = Math.floor(index / perChunk);

    if (!acc[chunkIndex]) {
      // Start a new array.
      acc[chunkIndex] = [];
    }

    acc[chunkIndex].push(item);

    return acc;
  }, []);
}

// Accepts an article number in the format 11122233366
// and returns it formatted as 111.222.333.66
export function formatArticleNo(articleNumber: string) {
  return articleNumber.replace(/(.{3})/g, '$1.');
}
